export function pushga(data: {
  event?: string;
  eventCategory: string;
  eventAction?: string;
  eventLabel?: string;
}) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    if (!data.event && data.eventCategory) data.event = data.eventCategory;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  } catch (error) {
    console.error(error);
  }
}

export function pushEcommerceGAEvent() {}
